import {User} from './user';

export class TimeSyncJiraIssue {
  id?: string;
  description: string;
  reporter: User;
  reporterEmail?: string;
  createdDate?: Date;
  updatedDate?: Date;
  updatedBy?: string;
  createdBy?: string;
  isSupport?: boolean;
  service: string;
  subject: string;
  type: string;
}
